import { I18n } from 'common/i18n';
import { AUTHORITY_OFFICIAL, AUTHORITY_COMMUNITY } from 'common/components/AssetBrowser/lib/constants';
import { FilterType, SelectOption } from './types';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { SelectDropdownConfig } from './filter-config';
import { FilterScope, getAllOption, getScope } from './translations';

const scope = getScope(FilterScope.Authority);

const getAuthorityOptions = (): SelectOption[] => {
  return [
    getAllOption(scope),
    {
      label: I18n.t('options.official', { scope }),
      value: AUTHORITY_OFFICIAL,
      leadingIcon: 'check_decagram',
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.community', { scope }),
      value: AUTHORITY_COMMUNITY,
      leadingIcon: 'account_group',
      leadingIconType: 'component',
    },
  ];
};

export const authorityConfigs: SelectDropdownConfig = {
  filterName: Filters.Authority,
  label: I18n.t('label', { scope }),
  getOptions: getAuthorityOptions,
  dispatchAction: filters.changeAuthority,
  filterType: FilterType.SelectDropdown,
};
